var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('bootstrap/transition');
require('bootstrap/collapse');
var vein = require('veinjs');

var BODY_SELECTOR = 'body';

var MAIN_EVENT_FILTER_CLASS = 'event-filters-open';
var EVENT_FILTERED_CLASS = 'event-filtered';

var DATA_RESET_SELECTOR = '[data-reset]';
var DATA_TIER_LOCATION_SELECTOR = '[data-locations="1"]';
var DATA_TOGGLE_EXPLORE_SELECTOR = '[data-toggle="explore"]';
var EVENTS_FILTERS_LIST_EVENTS_SELECTOR = '.js-events-filters-list-events';

var LOADING_SELECTOR = '.js-event-loading';
var OVERLAY_LOADING_SELECTOR = '.js-event-overlay-loading';

function EventFilters(el) {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

    this.$el = $(el);
	var body = $(BODY_SELECTOR);

	var locations = this.$el.find(DATA_TIER_LOCATION_SELECTOR);
	var list = this.$el.find(EVENTS_FILTERS_LIST_EVENTS_SELECTOR);
	var loader = this.$el.find(LOADING_SELECTOR);
	var overlay = this.$el.find(OVERLAY_LOADING_SELECTOR);

	var ajax_request_sent = false;

	// ajax function with filter radio locations
	function fetch_data_with_location(location) {
		var dataOrderBy = el.getAttribute('data-order-by');
		var dataIds = el.getAttribute('data-ids');
		var dataCatIds = el.getAttribute('data-cat-ids');
		var dataPerPage = el.getAttribute('data-per-page');
		var per_page = dataPerPage ? parseInt(dataPerPage) : 10;

		ajax_request_sent = true;
		$.ajax({
			type: 'get',
			url: "/wp-admin/admin-ajax.php",
			data: {
				action: 'fetch_location_event',
				page: 1,
				per_page: per_page,
				location: location,
				ids: dataIds,
				cat_ids: dataCatIds,
				order_by: dataOrderBy
			},
			dataType: 'json',
			beforeSend: function() {
				body.addClass('disable-scroll');
				loader.addClass('show');
				overlay.addClass('show');
			},
			complete: function() {
				setTimeout(function() {
					loader.removeClass('show');
					overlay.removeClass('show');
					body.removeClass('disable-scroll');
				}, 700);
			},
			success: function(response) {
				if (response && response.html) {
					var dataMaxPages = response.max_num_pages;
					var totalRecords = response.total;
					el.setAttribute('data-paged', 1);
					el.setAttribute('data-max-pages', dataMaxPages);
					el.setAttribute('data-total-records', totalRecords);

					list.empty();
					list.append(response.html);
				}
				// Unset the flag
				ajax_request_sent = false;
			},
			error: function(e) {
				console.log(e);
			}
		});
	}

	// ajax function with scroll
	function fetch_data_with_scroll(location) {
		var dataOrderBy = el.getAttribute('data-order-by');
		var dataIds = el.getAttribute('data-ids');
		var dataCatIds = el.getAttribute('data-cat-ids');
		var dataPerPage = el.getAttribute('data-per-page');
		var per_page = dataPerPage ? parseInt(dataPerPage) : 10;

		var dataPaged = el.getAttribute('data-paged');
		var paged = dataPaged ? parseInt(dataPaged) + 1 : 2;

		// Use the flag in the condition (so if sent and not yet received == false)
		if (!ajax_request_sent && $(window).scrollTop() >= $(el).offset().top + $(el).outerHeight() - window.innerHeight) {

			// Set the flag to prevent any concurring request
			ajax_request_sent = true;
			$.ajax({
				type: 'get',
				url: "/wp-admin/admin-ajax.php",
				data: {
					action: 'fetch_location_event',
					page: paged,
					per_page: per_page,
					location: location,
					ids: dataIds,
					cat_ids: dataCatIds,
					order_by: dataOrderBy,
				},
				dataType: 'json',
				beforeSend: function() {
					loader.addClass('show');
					overlay.addClass('show');
					body.addClass('disable-scroll');
				},
				complete: function() {
					setTimeout(function() {
						loader.removeClass('show');
						overlay.removeClass('show');
						body.removeClass('disable-scroll');
					}, 700);
				},
				success: function(response) {
					if (response && response.html) {
						var dataPaged = el.getAttribute('data-paged');
						var paged = dataPaged ? parseInt(dataPaged) : 1;

						var dataMaxPages = el.getAttribute('data-max-pages');
						var max_pages = dataMaxPages ? parseInt(dataMaxPages) : 0;

						if (paged >= max_pages) {
							return;
						} else {
							paged++;
							el.setAttribute('data-paged', paged);
							list.append(response.html);
						}
					}
					// Unset the flag
					ajax_request_sent = false;
				},
				error: function(e) {
					console.log(e);
				}
			});
		}
	}

	// click button filter open filters on mobile
	var toggleExplore = this.$el.find(DATA_TOGGLE_EXPLORE_SELECTOR);
	if (toggleExplore) {
		toggleExplore.on('click', function() {
			body.toggleClass(MAIN_EVENT_FILTER_CLASS);
		}.bind(this));
	}

	// Form radio on change
	$(document).on('change', 'input', function(e) {
		var $current = $(e.target);
		fetch_data_with_location($current.val());
	}.bind(this));

    // Resetting radios to unchecked when resetting filters
	var resetButton = this.$el.find(DATA_RESET_SELECTOR);
	if (resetButton) {
		resetButton.on('click', function(e) {
			e.preventDefault();
			body.removeClass(EVENT_FILTERED_CLASS);
			locations.filter('[value="all"]').prop('checked', true);
			fetch_data_with_location('all');
		}.bind(this));
	}

	$(window).on('scroll', function(e) {
		var locationChecked = $('input[data-locations="1"]:checked').val();
		fetch_data_with_scroll(locationChecked);
	});
}

module.exports = EventFilters;
